import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModuleVersionResourceRow } from "../types";

const ModuleVersionResourcesTableNameCell = ({
  item: resource,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionResourceRow>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{resource.id}</TableCellText>
    </TableSimpleCell>
  );
};

export default ModuleVersionResourcesTableNameCell;
